import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Input
} from 'semantic-ui-react'

const CardFallRiskAssessmentUX = (props: any) => {
    return(
      <div
        id="CardFallRiskAssessmentUX-div-0"
        style={{padding: "15px"}}>
        <div
          id="CardFallRiskAssessmentUX-div-18"
          style={{display: "flex" }}>
          
          <div
            id="CardFallRiskAssessmentUX-div-16"
            style={{padding: "5px", fontSize: "1.2rem", fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Fall Risk Assessment" : "การประเมินความเสี่ยงจากการล้ม"}
          </div>
          <div
            id="CardFallRiskAssessmentUX-div-19"
            style={{flex: 1}}>
            
          </div>
        </div>
        <Table
          data={props.data}
          headers="Date,User,Fall Risk Assessment,Nursing,Delete"
          id="CardFallRiskAssessment-Table"
          keys="date,user_fullname,fall_risk_description,nursing,delete"
          minRows="3"
          showPagination={false}
          style={{height: "150px"}}>
        </Table>
        <div
          id="CardFallRiskAssessmentUX-div-43"
          style={{ margin: "15px 25px" }}>
          
          <Form
            id="CardFallRiskAssessmentUX-Form-44">
            <FormGroup
              id="CardFallRiskAssessmentUX-FormGroup-66"
              inline={true}
              style={{ ...(props.version === "0.2" && { display: "none" }) }}>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-67"
                inline={true}
                width={3}>
                <div
                  id="CardFallRiskAssessmentUX-div-69">
                  {props.languageUX === "en" ? "Fall Risk Assessment" : "การประเมินความเสี่ยงจากการล้ม"}
                </div>
              </FormField>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-68"
                inline={true}
                width={3}>
                <div
                  id="CardFallRiskAssessmentUX-div-70"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardFallRiskAssessment-Dropdown-FallRisk"
                    onChange={props.changeFallRisk("fall_risk")}
                    options={props.fallRiskOptions}
                    selection={true}
                    value={props.fall_risk}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardFallRiskAssessmentUX-FormGroup-45"
              inline={true}
              style={{ ...(props.version !== "0.2" && { display: "none" }) }}>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-47"
                inline={true}
                width={3}>
                <div
                  id="CardFallRiskAssessmentUX-div-51">
                  {props.languageUX === "en" ? "Fall Risk Assessment" : "การประเมินความเสี่ยงจากการล้ม"}
                </div>
              </FormField>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-48"
                inline={true}
                width={3}>
                <div
                  id="CardFallRiskAssessmentUX-div-52"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    compact={true}
                    fluid={true}
                    id="CardFallRiskAssessment-Dropdown-FallRiskV2"
                    onChange={props.changeFallRisk("fall_riskV2")}
                    options={props.fallRiskOptions}
                    selection={true}
                    value={props.fall_riskV2}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-57"
                inline={true}
                style={{ ...(props.fall_riskV2 !== "HIG" && { display: "none" })  }}
                width={4}>
                <div
                  id="CardFallRiskAssessmentUX-div-58"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardFallRiskAssessment-Dropdown-FallRiskHight"
                    multiple={true}
                    onChange={props.changeFallRisk("fall_riskHigValue")}
                    options={props.fallRiskHigOptions}
                    selection={true}
                    value={props.fall_riskHigValue}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-60"
                inline={true}
                style={{ ...(!(props.fall_riskV2 === "HIG" && props.fall_riskHigValue.includes(9)) && { display: "none" })  }}
                width={3}>
                <div
                  id="CardFallRiskAssessmentUX-div-61"
                  style={{ width: "100%", display: "flex", alignItems: "center" }}>
                  
                  <div
                    id="CardFallRiskAssessmentUX-div-63"
                    style={{ marginRight: "10px" }}>
                    {props.languageUX === "en" ? "specify" : "ระบุ"}
                  </div>
                  <div
                    id="CardFallRiskAssessmentUX-div-64"
                    style={{ width: "100%" }}>
                    
                    <Input
                      id="CardFallRiskAssessment-Dropdown-FallRiskSpecific"
                      onChange={props.changeFallRisk("fall_riskText")}
                      value={props.fall_riskText}>
                    </Input>
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardFallRiskAssessmentUX-FormGroup-46"
              inline={true}>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-49"
                inline={true}
                width={3}>
                <div
                  id="CardFallRiskAssessmentUX-div-53">
                  {props.languageUX === "en" ? "Providing nursing care to patients" : "การให้การพยาบาลผู้ป่วย"}
                </div>
              </FormField>
              <FormField
                id="CardFallRiskAssessmentUX-FormField-50"
                inline={true}
                width={9}>
                <div
                  id="CardFallRiskAssessmentUX-div-54"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    compact={true}
                    fluid={true}
                    id="CardFallRiskAssessment-Dropdown-Nursing"
                    multiple={true}
                    onChange={props.changeFallRisk("nursing")}
                    options={props.fallRiskNursingOptions}
                    selection={true}
                    value={props.nursing}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardFallRiskAssessmentUX-div-41"
          style={{ display: "flex", justifyContent: "flex-end", margin: "0px 15px" }}>
          {}
          <Button
            color="blue"
            id="CardFallRiskAssessment-Button-Reassessment"
            onClick={props.onReassess}>
            {props.languageUX === "en" ? "Reassessment" : "การประเมินใหม่"}
          </Button>
          <div
            id="CardFallRiskAssessmentUX-div-72">
            {props.buttonSave}
          </div>
        </div>
      </div>
    )
}


export default CardFallRiskAssessmentUX

export const screenPropsDefault = {}

/* Date Time : Thu Feb 19 2026 12:26:18 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินความเสี่ยงจากการล้ม",
          "valueEN": "Fall Risk Assessment"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\", fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 17,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.data"
        },
        "headers": {
          "type": "value",
          "value": "Date,User,Fall Risk Assessment,Nursing,Delete"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Table"
        },
        "keys": {
          "type": "value",
          "value": "date,user_fullname,fall_risk_description,nursing,delete"
        },
        "minRows": {
          "type": "value",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"150px\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"0px 15px\" }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Button",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินใหม่",
          "valueEN": "Reassessment"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Button-Reassessment"
        },
        "onClick": {
          "type": "code",
          "value": "props.onReassess"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px 25px\" }"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Form",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-Form-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormGroup-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.version !== \"0.2\" && { display: \"none\" }) }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormGroup-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินความเสี่ยงจากการล้ม",
          "valueEN": "Fall Risk Assessment"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "การให้การพยาบาลผู้ป่วย",
          "valueEN": "Providing nursing care to patients"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-53"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Dropdown",
      "parent": 54,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Dropdown-Nursing"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeFallRisk(\"nursing\")"
        },
        "options": {
          "type": "code",
          "value": "props.fallRiskNursingOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.nursing"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Dropdown",
      "parent": 52,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Dropdown-FallRiskV2"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeFallRisk(\"fall_riskV2\")"
        },
        "options": {
          "type": "code",
          "value": "props.fallRiskOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.fall_riskV2"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.fall_riskV2 !== \"HIG\" && { display: \"none\" })  }"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Dropdown",
      "parent": 58,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Dropdown-FallRiskHight"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeFallRisk(\"fall_riskHigValue\")"
        },
        "options": {
          "type": "code",
          "value": "props.fallRiskHigOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.fall_riskHigValue"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!(props.fall_riskV2 === \"HIG\" && props.fall_riskHigValue.includes(9)) && { display: \"none\" })  }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบุ",
          "valueEN": "specify"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Input",
      "parent": 64,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Dropdown-FallRiskSpecific"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeFallRisk(\"fall_riskText\")"
        },
        "value": {
          "type": "code",
          "value": "props.fall_riskText"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormGroup-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.version === \"0.2\" && { display: \"none\" }) }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินความเสี่ยงจากการล้ม",
          "valueEN": "Fall Risk Assessment"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Dropdown",
      "parent": 70,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessment-Dropdown-FallRisk"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeFallRisk(\"fall_risk\")"
        },
        "options": {
          "type": "code",
          "value": "props.fallRiskOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.fall_risk"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardFallRiskAssessmentUX-div-72"
        }
      },
      "seq": 72,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 60,
  "isMounted": false,
  "memo": false,
  "name": "CardFallRiskAssessmentUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 75
}

*********************************************************************************** */
